<qr-code value="{{ code }}" size="{{ size }}" margin="{{ margin }}" errorCorrectionLevel="{{ errorCorrectionLevel }}"></qr-code>
